/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React from 'react'
import {ListItemIcon, ListItemText, MenuItem} from '@mui/material'
import {Refresh} from '@mui/icons-material'
import {FormattedMessage, useIntl} from 'react-intl'
import {clone, useError, useNotification, useParameters, useResolver, useTest} from '@enisco/mcc-react-lib'
import useFavoriteApps from '../../../../hooks/useFavoriteApps'
import useLoadProfile from '../../../../hooks/useLoadProfile'

interface Props {
  onClose: () => void
  favoriteId: string
}

export const UpdateFavorite: React.FC<Props> = ({onClose, favoriteId}) => {
  const resolver = useResolver()
  const test = useTest()
  const error = useError()
  const [favoriteApps] = useFavoriteApps()
  const [parameters] = useParameters()
  const [loadProfile] = useLoadProfile()
  const notification = useNotification()
  const intl = useIntl()

  const mockedData = {
    id: '123456',
    app: {module: 'mcc-portal', app: 'hardlink'},
    description: {default: 'Test'},
    groupId: '613af897816455bdc40b69c0',
    parameters: {children: {app: {param1: '132456789'}}},
    user: 'admin'
  }

  const updateFavorite = () => {
    const favorite = favoriteApps.find((fav) => fav.id === favoriteId)
    if (favorite) {
      const favoriteToUpdate = clone(favorite)
      favoriteToUpdate.parameters = parameters
      resolver('mcc-portal-api', '/internal/favorites/' + favoriteId, {
        options: {
          method: 'PUT',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(favoriteToUpdate)
        },
        mockedResponse: test ? JSON.stringify(mockedData) : undefined
      })
        .then(() => {
          onClose()
          return loadProfile()
        })
        .then(() => {
          notification(
            'success',
            intl.formatMessage({
              id: 'ProfileOptions.UpdateFavoriteSuccess',
              defaultMessage: 'Favorite has been updated'
            })
          )
        })
        .catch(error)
    }
  }

  return (
    <div>
      <MenuItem
        data-testid='UpdateFavorite:menu_item'
        onClick={() => updateFavorite()}
      >
        <ListItemIcon>
          <Refresh color={'primary'} />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage
            id='ProfileOptions.UpdateFavorite'
            defaultMessage='Update favorite'
          />
        </ListItemText>
      </MenuItem>
    </div>
  )
}
